/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
/**
 * @ignore - internal component.
 */ const ButtonGroupContext = /*#__PURE__*/ React.createContext({});
if ("production" !== 'production') {
    ButtonGroupContext.displayName = 'ButtonGroupContext';
}
export default ButtonGroupContext;
